import { Button, Divider, Box, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { ReactFlowProvider } from "reactflow"
import { match } from "ts-pattern"
import { AbsenceLeaveRequestDebugGraph } from "../../../../../components/absences/nodes-edges-simple-flow"
import { useCommand } from "../../../../../typed-client/hooks/use-command"
import { useSuspenseQueryGet } from "../../../../../typed-client/hooks/use-suspense-query-get"
import { Debug } from "../../../../../utils/debug"
import {
  showErrorNotification,
  showSuccessNotification,
} from "../../../../../utils/form-submission-notifications"
import { Page } from "../../../../../-components/Page"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/app/duties/leave-requests/debug-view/$id"
)({
  component: AbsenceDebugPage,
  beforeLoad: () => ({ getTitle: () => "Debug Approval workflow" }),
})

function AbsenceDebugPage() {
  const { t } = useTranslation("app_server")
  const id = parseInt(Route.useParams().id)
  const command = useCommand({
    url: "/api/Absence/Command",
    options: {
      onError: showErrorNotification,
      onSuccess: () => showSuccessNotification(t("Success")),
    },
  })
  const { data } = useSuspenseQueryGet(
    "/api/Absence/GetApprovalRequestForReview",
    { id }
  )
  return (
    <Page
      buttonGroupProps={{
        children: (
          <Button
            onClick={() =>
              command.mutate({
                streamId: id,
                command: {
                  Case: "ApprovalWorkflowCommand",
                  Fields: {
                    Case: "WorkflowCommand",
                    Fields: { Case: "ActivateNodes" },
                  },
                },
              })
            }
          >
            Activate nodes
          </Button>
        ),
      }}
    >
      <Divider label="Graph" />
      <div>
        <Text>Errors:</Text>
        {data.graphValidationErrors.map((v) =>
          match(v)
            .with({ Case: "NoTriggers" }, () => <div>No triggers</div>)
            .with({ Case: "NodeNotReachable" }, (x) => (
              <div>Unreachable: {x.Fields}</div>
            ))
            .exhaustive()
        )}
      </div>
      <Text>Approval Nodes: {data.allNodes.length}</Text>
      <Text>
        Workflow graph Nodes:{" "}
        {data.workflow.approvalWorkflow.graph.nodes.length} Edges:{" "}
        {data.workflow.approvalWorkflow.graph.edges.length}
      </Text>
      <Text>
        Approval nodes:{" "}
        {data.allNodes
          .map((node) => node.approvalNode.nodeId)
          .reduce((acc, val) => acc + val + ", ", "")}
      </Text>
      <Text>
        Graph nodes:{" "}
        {data.workflow.approvalWorkflow.graph.nodes
          .map((node) => node.nodeId)
          .reduce((acc, val) => acc + val + ", ", "")}
      </Text>
      <ReactFlowProvider>
        <AbsenceLeaveRequestDebugGraph
          graph={data.workflow.approvalWorkflow.graph}
          nodes={data.allNodes}
        />
      </ReactFlowProvider>
      <Divider label="Active nodes" />
      {data.activeNodes.map((node) => (
        <div>
          {node.approvalNode.nodeId} {node.approvalNode.details.Case}{" "}
          {node.approvalNode.updatedAt}
          <pre>{JSON.stringify(node.approvalNode.details, null, 2)}</pre>
        </div>
      ))}
      <Text>Workflow</Text>
      <pre>
        <div>{JSON.stringify(data.workflow, null, 2)}</div>
      </pre>
      <Box h={800}>
        <Debug _show {...data.workflow} style={{ height: 800 }} />
      </Box>
    </Page>
  )
}
